import React from "react";
import { ShieldCheck, IdCard, Sparkles, Clock } from "lucide-react";

/**
 * Compact trust indicators strip — GST Registered · Professional Drivers ·
 * Sanitized Vehicles · 24×7 Service. Designed to sit under the hero.
 */
const BADGES = [
    { icon: ShieldCheck, label: "GST Registered", detail: "Verified Pvt. Ltd. Company" },
    { icon: IdCard, label: "Professional Drivers", detail: "Licensed · Uniformed · Trained" },
    { icon: Sparkles, label: "Sanitized Vehicles", detail: "Deep cleaned before every trip" },
    { icon: Clock, label: "24×7 Service", detail: "Airports · Late-night · Weddings" },
];

export default function TrustBadges({ compact = false }) {
    return (
        <section
            data-testid="trust-badges"
            className={compact ? "border-y border-brand-navy/5 bg-brand-cream/40" : "bg-white"}
        >
            <div className="mx-auto max-w-7xl px-4 py-6 sm:py-8">
                <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
                    {BADGES.map(({ icon: Icon, label, detail }) => (
                        <div
                            key={label}
                            className="flex items-center gap-3 rounded-xl border border-brand-navy/5 bg-white p-3 shadow-soft transition-transform hover:-translate-y-0.5"
                        >
                            <span className="inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-brand-navy text-brand-gold">
                                <Icon className="h-4 w-4" />
                            </span>
                            <div className="min-w-0">
                                <div className="truncate font-display text-sm font-extrabold text-brand-navy">{label}</div>
                                <div className="truncate text-[11px] text-brand-slate">{detail}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
